import { Container, Drawer, Dropdown, Overlay, RouteLink } from './styles'

import { ReactComponent as GridIcon } from './assets/grid.svg'
import { ReactComponent as X } from './assets/x.svg'
import useGetAppRoutes from '../../../../hooks/use-get-app-routes'
import { useState } from 'react'
import { RoutesIcons } from './data'
import { useClickOutside } from '../../../../hooks/use-click-outside'

interface IProps {
  onClick?(): void
}

const RoutesDropdown: React.FC<IProps> = (props) => {
  const routes = useGetAppRoutes()
  const [isOpen, setIsOpen] = useState(false)

  const containerRef = useClickOutside(() => window.innerWidth > 800 && setIsOpen(false))

  const renderLinks = () =>
    routes
      .filter((t) => t.active)
      .map((route) => (
        <RouteLink to={route.path} key={route.path}>
          {RoutesIcons[route.path]} {route.name}
        </RouteLink>
      ))

  return (
    <Container ref={containerRef}>
      <button
        className="button"
        onClick={() => {
          setIsOpen((state) => !state)
          if (props.onClick) props.onClick()
        }}
      >
        <X className="icon" data-is-visible={isOpen} />

        <GridIcon className="icon" data-is-visible={!isOpen} />
      </button>

      <Overlay data-is-visible={isOpen} onClick={() => setIsOpen(false)} />

      <Drawer data-is-open={isOpen}>{renderLinks()}</Drawer>

      <Dropdown data-is-open={isOpen}>{renderLinks()}</Dropdown>
    </Container>
  )
}

export default RoutesDropdown
